<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter" title="Abbreviations">
<h2 class="h2b"><a id="page_xvi"></a><a id="frontmatter03"></a>ABBREVIATIONS</h2>
<table>
<tbody><tr>
<td style="width:20%"><p class="para">AA</p></td>
<td style="width:80%"><p class="para">Antiaircraft</p></td>
</tr>
<tr>
<td><p class="para">AAA</p></td>
<td><p class="para">Antiaircraft Artillery</p></td>
</tr>
<tr>
<td><p class="para">AAA AW</p></td>
<td><p class="para">Antiaircraft Artillery Automatic Weapons</p></td>
</tr>
<tr>
<td><p class="para">A&amp;P</p></td>
<td><p class="para">Ammunition and Pioneer</p></td>
</tr>
<tr>
<td><p class="para">ARCT</p></td>
<td><p class="para">Airborne Regimental Combat Team</p></td>
</tr>
<tr>
<td><p class="para">AST</p></td>
<td><p class="para">Ammunition Supply Point</p></td>
</tr>
<tr>
<td><p class="para">AT&amp;M</p></td>
<td><p class="para">Antitank and Mine</p></td>
</tr>
<tr>
<td><p class="para">BAR</p></td>
<td><p class="para">Browning Automatic Rifle</p></td>
</tr>
<tr>
<td><p class="para">BCT</p></td>
<td><p class="para">Battalion Combat Team</p></td>
</tr>
<tr>
<td><p class="para">CCF</p></td>
<td><p class="para">Chinese Communist Forces</p></td>
</tr>
<tr>
<td><p class="para">CG</p></td>
<td><p class="para">Commanding General</p></td>
</tr>
<tr>
<td><p class="para">CO</p></td>
<td><p class="para">Commanding Officer</p></td>
</tr>
<tr>
<td><p class="para">CP</p></td>
<td><p class="para">Command Post or Check Point</p></td>
</tr>
<tr>
<td><p class="para">DivArty</p></td>
<td><p class="para">Division Artillery</p></td>
</tr>
<tr>
<td><p class="para">DUKW</p></td>
<td><p class="para">Amphibious Truck</p></td>
</tr>
<tr>
<td><p class="para">EMT</p></td>
<td><p class="para">Emergency Medical Tag</p></td>
</tr>
<tr>
<td><p class="para">FA</p></td>
<td><p class="para">Field Artillery</p></td>
</tr>
<tr>
<td><p class="para">FAC</p></td>
<td><p class="para">Forward Air Controller</p></td>
</tr>
<tr>
<td><p class="para">FM</p></td>
<td><p class="para">Frequency Modulation</p></td>
</tr>
<tr>
<td><p class="para">FO</p></td>
<td><p class="para">Forward Observer</p></td>
</tr>
<tr>
<td><p class="para">G-1/S-1</p></td>
<td><p class="para">Personnel Officer</p></td>
</tr>
<tr>
<td><p class="para">G-2/S-2</p></td>
<td><p class="para">Intelligence Officer</p></td>
</tr>
<tr>
<td><p class="para">G-3/S-3</p></td>
<td><p class="para">Operations Officer</p></td>
</tr>
<tr>
<td><p class="para">G-4/S-4</p></td>
<td><p class="para">Supply Officer</p></td>
</tr>
<tr>
<td><p class="para">HE</p></td>
<td><p class="para">High Explosive</p></td>
</tr>
<tr>
<td><a id="page_xvii"></a><p class="para">HEAT</p></td>
<td><p class="para">High Explosive Antitank</p></td>
</tr>
<tr>
<td><p class="para">HMG</p></td>
<td><p class="para">Heavy Machine Gun</p></td>
</tr>
<tr>
<td><p class="para">HQ</p></td>
<td><p class="para">Headquarters</p></td>
</tr>
<tr>
<td><p class="para">I&amp;R</p></td>
<td><p class="para">Intelligence and Reconnaissance</p></td>
</tr>
<tr>
<td><p class="para">JCS</p></td>
<td><p class="para">Joint Chiefs of Staff</p></td>
</tr>
<tr>
<td><p class="para">KATUSA</p></td>
<td><p class="para">Korean Augmentation Troops for the United States Army</p></td>
</tr>
<tr>
<td><p class="para">KIA</p></td>
<td><p class="para">Killed in Action</p></td>
</tr>
<tr>
<td><p class="para">KM AG</p></td>
<td><p class="para">Korean Military Advisory Group</p></td>
</tr>
<tr>
<td><p class="para">LD</p></td>
<td><p class="para">Line of Departure</p></td>
</tr>
<tr>
<td><p class="para">LST</p></td>
<td><p class="para">Landing Ship Tank</p></td>
</tr>
<tr>
<td><p class="para">MG</p></td>
<td><p class="para">Machine Gun</p></td>
</tr>
<tr>
<td><p class="para">MIA</p></td>
<td><p class="para">Missing in Action</p></td>
</tr>
<tr>
<td><p class="para">MLR</p></td>
<td><p class="para">Main Line of Resistance</p></td>
</tr>
<tr>
<td><p class="para">MSR</p></td>
<td><p class="para">Main Supply Road</p></td>
</tr>
<tr>
<td><p class="para">NCO</p></td>
<td><p class="para">Noncommissioned Officer</p></td>
</tr>
<tr>
<td><p class="para">NK</p></td>
<td><p class="para">North Korea</p></td>
</tr>
<tr>
<td><p class="para">OP</p></td>
<td><p class="para">Observation Post; Outpost</p></td>
</tr>
<tr>
<td><p class="para">OPL</p></td>
<td><p class="para">Outpost Line</p></td>
</tr>
<tr>
<td><p class="para">OPLR</p></td>
<td><p class="para">Outpost Line of Resistance</p></td>
</tr>
<tr>
<td><p class="para">P&amp;A</p></td>
<td><p class="para">Pioneer and Ammunition</p></td>
</tr>
<tr>
<td><p class="para">PLA</p></td>
<td><p class="para">People’s Liberation Army (Chinese Communist)</p></td>
</tr>
<tr>
<td><p class="para">POL</p></td>
<td><p class="para">Petroleum, Oil, and Lubrication</p></td>
</tr>
<tr>
<td><p class="para">POW</p></td>
<td><p class="para">Prisoner of War</p></td>
</tr>
<tr>
<td><p class="para">RCT</p></td>
<td><p class="para">Regimental Combat Team</p></td>
</tr>
<tr>
<td><p class="para">Recon</p></td>
<td><p class="para">Reconnaissance</p></td>
</tr>
<tr>
<td><p class="para">ROK</p></td>
<td><p class="para">Republic of Korea (South Korean)</p></td>
</tr>
<tr>
<td><p class="para">R&amp;R</p></td>
<td><p class="para">Rest and Recreation</p></td>
</tr>
<tr>
<td><p class="para">SCR</p></td>
<td><p class="para">Signal Corps Radio</p></td>
</tr>
<tr>
<td><p class="para">SOI</p></td>
<td><p class="para">Signal Operating Instructions</p></td>
</tr>
<tr>
<td><p class="para">SOP</p></td>
<td><p class="para">Standard Operating Procedure</p></td>
</tr>
<tr>
<td><p class="para">SP</p></td>
<td><p class="para">Self-propelled</p></td>
</tr>
<tr>
<td><p class="para">TACP</p></td>
<td><p class="para">Tactical Air Control Party</p></td>
</tr>
<tr>
<td><p class="para">TF</p></td>
<td><p class="para">Task Force</p></td>
</tr>
<tr>
<td><p class="para">T/O&amp;E</p></td>
<td><p class="para">Table of Organization and Equipment</p></td>
</tr>
<tr>
<td><p class="para">UN</p></td>
<td><p class="para">United Nations</p></td>
</tr>
<tr>
<td><p class="para">VT</p></td>
<td><p class="para">Variable Time Fuse</p></td>
</tr>
<tr>
<td><a id="page_xviii"></a><p class="para">WIA</p></td>
<td><p class="para">Wounded in Action</p></td>
</tr>
<tr>
<td><p class="para">WP</p></td>
<td><p class="para">White Phosphorous</p></td>
</tr>
<tr>
<td><p class="para1"><strong>RANKS</strong></p></td>
<td><p class="para1"> </p></td>
</tr>
<tr>
<td><p class="para1">Pvt.</p></td>
<td><p class="para1">Private</p></td>
</tr>
<tr>
<td><p class="para">PFC</p></td>
<td><p class="para">Private 1st Class</p></td>
</tr>
<tr>
<td><p class="para">Cpl.</p></td>
<td><p class="para">Corporal</p></td>
</tr>
<tr>
<td><p class="para">Sgt.</p></td>
<td><p class="para">Sergeant</p></td>
</tr>
<tr>
<td><p class="para">S. Sgt.</p></td>
<td><p class="para">Staff Sergeant</p></td>
</tr>
<tr>
<td><p class="para">SFC</p></td>
<td><p class="para">Sergeant 1st Class</p></td>
</tr>
<tr>
<td><p class="para">M. Sgt.</p></td>
<td><p class="para">Master Sergeant</p></td>
</tr>
<tr>
<td><p class="para">1st Sgt.</p></td>
<td><p class="para">First Sergeant</p></td>
</tr>
<tr>
<td><p class="para">WOJG</p></td>
<td><p class="para">Warrant Officer Junior Grade</p></td>
</tr>
<tr>
<td><p class="para">CWO</p></td>
<td><p class="para">Chief Warrant Officer</p></td>
</tr>
<tr>
<td><p class="para">Lt.</p></td>
<td><p class="para">Lieutenant</p></td>
</tr>
<tr>
<td><p class="para">LtJG</p></td>
<td><p class="para">Lieutenant Junior Grade</p></td>
</tr>
<tr>
<td><p class="para">2d Lt.</p></td>
<td><p class="para">2d Lieutenant</p></td>
</tr>
<tr>
<td><p class="para">1st Lt.</p></td>
<td><p class="para">1st Lieutenant</p></td>
</tr>
<tr>
<td><p class="para">Capt.</p></td>
<td><p class="para">Captain</p></td>
</tr>
<tr>
<td><p class="para">Maj.</p></td>
<td><p class="para">Major</p></td>
</tr>
<tr>
<td><p class="para">Lt. Col.</p></td>
<td><p class="para">Lieutenant Colonel</p></td>
</tr>
<tr>
<td><p class="para">Col.</p></td>
<td><p class="para">Colonel</p></td>
</tr>
<tr>
<td><p class="para">Gen.</p></td>
<td><p class="para">General</p></td>
</tr>
<tr>
<td><p class="para">Brig. Gen.</p></td>
<td><p class="para">Brigadier General</p></td>
</tr>
<tr>
<td><p class="para">Maj. Gen.</p></td>
<td><p class="para">Major General</p></td>
</tr>
<tr>
<td><p class="para">Lt. Gen.</p></td>
<td><p class="para">Lieutenant General</p></td>
</tr>
</tbody></table>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter03.vue?7ce20aea